import { DefaultButton } from "components/Shared/DefaultButton";
import { useIntl } from "react-intl";

type Props = {
  disabled: boolean;
  isLoading: boolean;
  onClick: () => void;
};

export const SelectAllButton = ({ disabled, isLoading, onClick }: Props) => {
  const { formatMessage } = useIntl();

  return (
    <DefaultButton type="default" disabled={disabled} loading={isLoading} onClick={onClick}>
      {formatMessage({ id: "button.selectAll" })}
    </DefaultButton>
  );
};
